import { ComponentType, createElement } from 'react';

import { rollbar } from '@utils';

class SubModuleRegistryClass {
  private registry = new Map<string, ComponentType>();

  register(name: string, component: ComponentType): void {
    if (this.registry.has(name)) {
      rollbar.warning(
        `Warning: A module with the name '${name}' is already registered.`
      );
      return;
    }
    this.registry.set(name, component);
  }

  getSubModule(name: string): ComponentType {
    const component = this.registry.get(name);
    if (!component) {
      rollbar.error(
        `Error: No sub-module found with the name '${name}' in the registry.`
      );
      return () => createElement('div', null, `sub module ${name} not found`);
    }
    return component;
  }

  listRegisteredSubModules(): string[] {
    return Array.from(this.registry.keys());
  }

  listRegistryAsNamedArray(): {
    name: string;
    component: ComponentType;
  }[] {
    return Array.from(this.registry.entries()).map(([name, component]) => ({
      name,
      component,
    }));
  }
}

export const SubModuleRegistry = new SubModuleRegistryClass();
